module.exports = __webpack_public_path__ + "static/media/Clear_Icon.9891c5da.svg";